module.exports = __webpack_public_path__ + "img/pantalla2-5.3e760e39.png";